import CasinoImageBox from "components/casinoImageBox";
import { useSelector } from "react-redux";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import Appconfig from '../../config/config'

function Vivo() {
    const profileData = useSelector((state) => state.authSlice.profileData);
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    function CreateAndLaunchWCOCasino(provider_code, game_code, type) {
        if (!isAuthenticated) {
            NotificationManager.error('Please login to play.', '', 1000);
            return;
        }
        if (profileData?.is_casino_bet_lock == 'Yes') {
            NotificationManager.error('Casino Block By Upline.', '', 1000);

            return;
        }
        const userData = {
            user_id: profileData?._id,
            user_name: profileData?.user_name,
            redirect_url: window.location.href,
            provider_code: provider_code,
            game_code: game_code,
            type: type,
        };

        var config = {
            method: "post",
            url: `${Appconfig.casinoUrl}wco/login`,
            headers: {
                "Content-Type": "application/json",
            },

            data: JSON.stringify(userData),
        };

        axios(config)
            .then(function (response) {
                let status = response.data.status?.code;
                if (status === "SUCCESS") {
                    window.open(response.data.launchURL, "_self");
                }

                if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
                    NotificationManager.error('Game Not Found.', '', 1000);
                } else if (status == "AUTHENTICATION_FAILED") {
                    NotificationManager.error(response.data.status?.message, '', 1000);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    return (
        <>
            <div className='relative w-full'>
                <div className="grid grid-cols-12 lg:px-[6px]">
                    <div className="col-span-12">
                        <div className="bg-[#fff] h-auto relative">
                            <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>
                                <span className="max-w-[220px] lg:max-w-[465px] float-left m-0 overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap">Casino</span>
                            </p>
                        </div>
                    </div>
                    <div className="col-span-12">
                        <section className="block">
                            <div className="ml-auto mr-auto  w-full">
                                <div className="grid grid-cols-12 gap-y-[10px] !mt-[20px] !mb-[.5rem] ">
                                    {
                                        Array.from({ length: 12 }).map((image, index) => (
                                            <CasinoImageBox key={index} src={`/assets/images/vivo/vivo${index + 2}.webp`} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
                                        ))
                                    }
                                </div>
                            </div>

                        </section>

                    </div>
                </div>

            </div>
        </>
    );
}

export default Vivo;